import { FormFieldAutocomplete } from '@/global/components/Form'
import IconeAjuda from '@/global/components/IconeAjuda'
import Grid from '@/global/components/ui/Grid'
import { type Destinatario, DESTINATARIOS } from '@acme/core'
import { MailIcon } from 'lucide-react'
import type { AcaoUi } from './acao-ui'

const PARAMETROS_INICIAIS = {
    destinatarios: [],
    titulo: 'Notificação de rotina',
    mensagem: '{motivo}',
}

type DestinatarioGerente = Exclude<Destinatario, 'funcionario'>
const DESTINATARIOS_GERENTE = DESTINATARIOS.filter(it => it !== 'funcionario')

const ROTULO_DESTINATARIO: Record<DestinatarioGerente, string> = {
    gestores: 'Gestores',
    administradores: 'Administradores',
}

export const notificarEmail: AcaoUi = {
    icone: MailIcon,
    parametrosIniciais: PARAMETROS_INICIAIS,
    Parametros: () => (
        <Grid item xs={12}>
            <FormFieldAutocomplete
                name="parametros.destinatarios"
                label="Destinatários"
                multiple
                required
                options={DESTINATARIOS_GERENTE}
                getOptionLabel={(destinatario: DestinatarioGerente) =>
                    ROTULO_DESTINATARIO[destinatario]
                }
                isOptionEqualToValue={(opcao, valor) => opcao === valor}
                endAdornment={
                    <IconeAjuda>
                        <b>Gestores:</b> supervisores com permissão para o
                        funcionário.
                        <br />
                        <br />
                        <b>Administradores:</b> todos os usuários
                        administradores do cliente.
                    </IconeAjuda>
                }
            />
        </Grid>
    ),
}
